var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 470,
    height: 468,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "111.8%",
    height: "111.9%",
    x: "-5.9%",
    y: "-3.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.078125 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.210824275 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M9.635 132.808C24.782 59.782 71.388 19.109 144.085 6.822c53.74-9.081 107.5-9.196 161.15.255 74.852 13.185 119.85 56.23 134.185 130.36 11.075 57.29 11.249 115.191-.174 172.427-15.324 72.52-63.132 117.285-135.561 129.527-53.74 9.08-107.5 9.195-161.15-.255-74.852-13.186-120.05-58.38-134.384-132.509-11.64-57.668-10.52-115.935 1.484-173.82z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0BCD74",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m138.895 213.02 17.407-6.4s13.417 26.742 39.906 53.232c26.488 26.488 55.81 40.86 55.81 40.86l-7.512 17.582s-33.023-19.115-60.324-46.417c-27.302-27.302-45.287-58.856-45.287-58.856zm194.656 82.804c11.789 5.862 14.355 21.561 5.045 30.871l-39.908 39.908a26.024 26.024 0 0 1-22.461 7.312 196.318 196.318 0 0 1-8.139-1.469c-24.361-3.308-72.288-15.714-118.358-61.784-48.63-48.63-62.496-103.109-66.412-127.923a26.021 26.021 0 0 1 7.312-22.46l39.908-39.908c9.31-9.311 25.009-6.745 30.871 5.045l30.801 61.942-15.395 7.6-28.546-57.82c-1.658-3.357-6.125-4.094-8.773-1.446l-32.677 32.677a17.288 17.288 0 0 0-5.05 12.913c.558 14.136 4.742 41.303 25.147 74.059 8.381 12.502 19.267 25.99 33.414 40.136 48.938 48.939 93.267 58.407 114.562 59.832 2.901-.058 5.18-.265 6.775-.467 2.106-.267 4.155-.924 5.951-2.054a16.984 16.984 0 0 0 2.979-2.374l32.677-32.677c2.648-2.648 1.912-7.115-1.447-8.773l-57.819-28.546 7.601-15.395 61.942 30.801zm-99.612-120.923a6.55 6.55 0 0 1-6.55-6.549v-48.118h14.334v30.198L290.155 102l10.135 10.135-48.432 48.433h30.198v14.333H233.94zm122.802 18.334 14.334-10v23.167H356.74v-13.167zM299.11 216l49.934-49.933h-32.637v-14.333h47.126a5.542 5.542 0 0 1 5.54 5.541v8.792h-.24l.24.241-59.827 59.827L299.112 216z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3a4db9171cf834e5e4949a1a5371cac8.svg";
export { ForwardRef as ReactComponent };